// src/components/analytics/components/SummaryCards.js
import React from 'react';
import { Grid, Card, Box, Typography, alpha, useTheme } from '@mui/material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

// Utility function to format currency
const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(value);
};

const SummaryCards = ({ data }) => {
    const theme = useTheme();

    // Prepare summary data
    const getSummaryData = () => {
        if (!data || data.length === 0) return [];

        const totalIncome = data.reduce((sum, item) => sum + item.transactions, 0);
        const totalExpenses = data.reduce((sum, item) => sum + item.expenses, 0);
        const netProfit = totalIncome - totalExpenses;
        const profitMargin = totalIncome > 0 ? (netProfit / totalIncome * 100).toFixed(1) : 0;

        return [
            {
                title: "Total Income",
                value: totalIncome,
                change: "+5.2%",
                positive: true,
                icon: <AttachMoneyIcon />,
                color: theme.palette.success.main
            },
            {
                title: "Total Expenses",
                value: totalExpenses,
                change: "-2.1%",
                positive: false,
                icon: <MoneyOffIcon />,
                color: theme.palette.error.main
            },
            {
                title: "Net Profit",
                value: netProfit,
                change: "+8.4%",
                positive: true,
                icon: <AccountBalanceWalletIcon />,
                color: theme.palette.primary.main
            },
            {
                title: "Profit Margin",
                value: `${profitMargin}%`,
                change: "+1.8%",
                positive: true,
                icon: <TrendingUpIcon />,
                color: theme.palette.info.main,
                isPercentage: true
            }
        ];
    };

    return (
        <Grid container spacing={3} sx={{ mb: 3 }}>
            {getSummaryData().map((item, index) => (
                <Grid item xs={12} sm={6} md={3} key={`summary-card-${index}`}>
                    <Card
                        elevation={0}
                        sx={{
                            p: 2,
                            borderRadius: 2,
                            height: '100%',
                            border: `1px solid ${theme.palette.divider}`,
                            transition: 'transform 0.3s, box-shadow 0.3s',
                            '&:hover': {
                                transform: 'translateY(-5px)',
                                boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
                            }
                        }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                            <Typography variant="subtitle2" color="text.secondary">
                                {item.title}
                            </Typography>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    bgcolor: alpha(item.color, 0.1),
                                    color: item.color,
                                    borderRadius: '50%',
                                    p: 1
                                }}
                            >
                                {item.icon}
                            </Box>
                        </Box>
                        <Typography variant="h5" fontWeight="bold" sx={{ mb: 1 }}>
                            {item.isPercentage ? item.value : formatCurrency(item.value)}
                        </Typography>
{/*
                        <Box display="flex" alignItems="center">
                            {item.positive ? (
                                <ArrowUpwardIcon sx={{ fontSize: 16, color: 'success.main', mr: 0.5 }} />
                            ) : (
                                <ArrowDownwardIcon sx={{ fontSize: 16, color: 'error.main', mr: 0.5 }} />
                            )}
                            <Typography
                                variant="body2"
                                color={item.positive ? 'success.main' : 'error.main'}
                                sx={{ mr: 1 }}
                            >
                                {item.change}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                vs previous year
                            </Typography>
                        </Box>
*/}
                    </Card>
                </Grid>
            ))}
        </Grid>
    );
};

export default SummaryCards;